import {
  DEFAULT_PLATFORM_FEATURE_FLAGS,
  type PlatformFeatureFlagKey,
  type PlatformFeatureFlags,
} from '../constants/platformFeatureFlags';

export function mergeFeatureFlags(partial: Partial<PlatformFeatureFlags> | undefined): PlatformFeatureFlags {
  return { ...DEFAULT_PLATFORM_FEATURE_FLAGS, ...partial };
}

export function isFeatureEnabled(
  key: PlatformFeatureFlagKey,
  flags: PlatformFeatureFlags = DEFAULT_PLATFORM_FEATURE_FLAGS,
): boolean {
  return flags[key] !== false;
}
